import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search,searchCountry) => {
  return await GET(
    `/admin/masters/state?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&searchCountry=${
        searchCountry || ""
      }`
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/masters/state/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/masters/state`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/masters/state/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/masters/state/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/masters/state/${id}`);
};
